const localStorageGetObject = key => JSON.parse(localStorage.getItem(key));
const localStorageSetItem = (key, value) => localStorage.setItem(key, JSON.stringify(value));
const localStorageRemoveItem = key => localStorage.removeItem(key);
// Local Storage
// GET
export const lsGetOfferGuid = () => localStorageGetObject('offer:guid');
export const lsGetAuthToken = () => localStorageGetObject('auth:token');
export const lsGetAuthTokenBBVA = () => localStorageGetObject('auth:btk');
export const lsGetAuthToken2faBBVA = () => localStorageGetObject('auth:btk:2fa');
export const lsGetTicketBBVA = () => localStorageGetObject('auth:btk:ticket');
export const lsGetClientConsents = () => localStorageGetObject('client:consents');
// SET
export const lsSetOfferGuid = value => localStorageSetItem('offer:guid', value);
export const lsSetAuthToken = value => localStorageSetItem('auth:token', value);
export const lsSetAuthTokenBBVA = value => localStorageSetItem('auth:btk', value);
export const lsSetAuthToken2faBBVA = value => localStorageSetItem('auth:btk:2fa', value);
export const lsSetTicketBBVA = value => localStorageSetItem('auth:btk:ticket', value);
export const lsSetClientConsents = value => localStorageSetItem('client:consents', value);
// REVOME
export const lsRemoveOfferGuid = () => {
  localStorageRemoveItem('offer:guid');
};
export const lsRemoveAuthToken = () => {
  localStorageRemoveItem('auth:token');
};
export const lsRemoveAuthTokenBBVA = () => {
  localStorageRemoveItem('auth:btk');
};
export const lsRemoveAuthToken2faBBVA = () => {
  localStorageRemoveItem('auth:btk:2fa');
};
export const lsRemoveTicketBBVA = () => {
  localStorageRemoveItem('auth:btk:ticket');
};
export const lsRemoveClientConsents = () => {
  localStorageRemoveItem('client:consents');
};
